import { TimePicker } from "components/designV2/timePicker/timePicker";
import type { ComponentProps } from "react";
import {
  InlineFieldGroup,
  InlineFieldLabel,
  KeyLabel,
  KeyValueRow,
  TimePickerWrap,
} from "./timeReportDetailsPanel.styled";

type TimePickerValue = ComponentProps<typeof TimePicker>["value"];
type TimePickerOnChange = ComponentProps<typeof TimePicker>["onChange"];

interface EditableRangeRowProps {
  label: string;
  fromLabel: string;
  toLabel: string;
  startValue: TimePickerValue;
  endValue: TimePickerValue;
  onStartChange: TimePickerOnChange;
  onEndChange: TimePickerOnChange;
}

export const EditableRangeRow = (props: EditableRangeRowProps): JSX.Element => {
  return (
    <KeyValueRow>
      <KeyLabel>{props.label}</KeyLabel>
      <InlineFieldGroup>
        <InlineFieldLabel>{props.fromLabel}</InlineFieldLabel>
        <TimePickerWrap>
          <TimePicker
            ariaLabel={props.fromLabel}
            value={props.startValue}
            onChange={props.onStartChange}
            size="compact"
          />
        </TimePickerWrap>
        <InlineFieldLabel>{props.toLabel}</InlineFieldLabel>
        <TimePickerWrap>
          <TimePicker
            ariaLabel={props.toLabel}
            value={props.endValue}
            onChange={props.onEndChange}
            size="compact"
          />
        </TimePickerWrap>
      </InlineFieldGroup>
    </KeyValueRow>
  );
};
